import React from "react";
import { Close } from "../../../assets/svg";
import { RadioButton } from "../../../components/micro/input";

const Filterpanel = ({
  show,
  onClose,
  roles,
  setRoles,
  paymentStatus,
  setPaymentStatus,
  modifiedDate,
  setModifiedDate,
  onApply,
}) => {
  const toggleRole = (role) => {
    if (role === "All") return setRoles(["All"]);
    const updated = roles.includes(role)
      ? roles.filter((r) => r !== role)
      : [...roles.filter((r) => r !== "All"), role];
    setRoles(updated.length ? updated : ["All"]);
  };

  const togglePaymentStatus = (status) => {
    if (status === "All") return setPaymentStatus(["All"]);
    const updated = paymentStatus.includes(status)
      ? paymentStatus.filter((s) => s !== status)
      : [...paymentStatus.filter((s) => s !== "All"), status];
    setPaymentStatus(updated.length ? updated : ["All"]);
  };

  const resetFilter = () => {
    setModifiedDate("latest_modified_date");
    setRoles(["All"]);
    setPaymentStatus(["All"]);
    onClose();
  };

  return (
    <div>
      <div
        className={`backdrop-blur-sm bg-black/40 fixed left-0 right-0 bottom-0 top-[64px] z-[9999] ${
          show ? "block" : "hidden"
        }`}
      >
        <div className="absolute top-0 right-0 bottom-0 h-full w-[500px] bg-white p-10 shadow-lg z-50 overflow-y-auto">
          <div className="flex justify-between items-center mb-4 border-b border-stepGray">
            <p className="text-xl text-primaryBlack mb-5">Filter</p>
            <button onClick={onClose}>
              <Close />
            </button>
          </div>

          {/* Sort */}
          <div className="mb-6">
            <h4 className="text-sm mb-4 text-darkblack">SORT BY</h4>
            <div className="space-y-3 text-sm">
              <div className="flex gap-2">
                <RadioButton
                  type="radio"
                  name="sort"
                  value="latest_modified_date"
                  checked={modifiedDate === "latest_modified_date"}
                  onChange={() => setModifiedDate("latest_modified_date")}
                  className={"space-x-0"}
                />
                <label> Latest Modified Date</label>
              </div>
              <div className="flex gap-2 ">
                <RadioButton
                  type="radio"
                  name="sort"
                  value="oldest_modified_date"
                  checked={modifiedDate === "oldest_modified_date"}
                  onChange={() => setModifiedDate("oldest_modified_date")}
                  className={"space-x-0"}
                />
                <label> Oldest Modified Date</label>
              </div>
            </div>
          </div>

          {/* Role */}
          <div className="mb-6">
            <h4 className="text-sm mb-4 text-darkblack">ROLE</h4>
            {["All", "Electrician", "Gas", "Plumbing"].map((role) => (
              <label
                key={role}
                className="flex items-center gap-2 text-sm mb-3 ml-3"
              >
                <input
                  type="checkbox"
                  checked={roles.includes(role)}
                  onChange={() => toggleRole(role)}
                  className="w-4 h-4 mr-2 accent-themeBtn"
                />
                {role}
              </label>
            ))}
          </div>

          {/* Payment */}
          <div className="mb-6">
            <h4 className="text-sm mb-4 text-darkblack">PAYMENT STATUS</h4>
            {["All", "Paid", "Unpaid"].map((status) => (
              <label
                key={status}
                className="flex items-center gap-2 text-sm mb-3 ml-3"
              >
                <input
                  type="checkbox"
                  checked={paymentStatus.includes(status)}
                  onChange={() => togglePaymentStatus(status)}
                  className="w-4 h-4 mr-2 accent-themeBtn space-x-1"
                />
                {status}
              </label>
            ))}
          </div>

          {/* Buttons */}
          <div className="absolute bottom-6 left-0 w-full px-6 ">
            <div className="flex justify-between items-center gap-2  border-t border-stepGray pt-4">
              <button
                onClick={resetFilter}
                onClose={onClose}
                className="w-1/2 text-sm bg-white text-primaryBlack border border-primaryBlack flex items-center justify-center px-6 py-2 rounded uppercase font-Proxima"
              >
                RESET ALL
              </button>
              <button
                onClick={onApply}
                className="w-1/2 text-sm bg-themeBtn text-bgWhite flex items-center justify-center px-6 py-2 rounded uppercase font-Proxima"
              >
                APPLY
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filterpanel;
